module.exports = __webpack_public_path__ + "4d4309b5e514e6b22de66282c58dc6b0.svg";